var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtendimentosConcluidos({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.82,
    height: 90.795,
    viewBox: "0 0 91.82 90.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.25 94.557) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.912,31,20.456,46.456,5,31",
    transform: "translate(0 31.408)",
    fill: "none",
    stroke: "#bcc8d1",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.952,5H29.664A17.716,17.716,0,0,0,12,22.664V75.656M53.952,35.912,69.408,20.456,84.864,35.912",
    transform: "translate(8.456 0)",
    fill: "none",
    stroke: "#bcc8d1",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,83.656H43.288A17.716,17.716,0,0,0,60.952,65.992V13",
    transform: "translate(16.912 9.664)",
    fill: "none",
    stroke: "#bcc8d1",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtendimentosConcluidos);
export default __webpack_public_path__ + "static/media/atendimentos_concluidos.ff16699ebe9ef4cbf524cc0abb736aca.svg";
export { ForwardRef as ReactComponent };